import Rest from '../rest'

/******************************************************************************
 *  Simulations
 *****************************************************************************/

/**
 * @type {Task}
 */
export default class Simulation extends Rest {

    constructor () {
        super('/simulations')
    }
}